module.exports = __webpack_public_path__ + "static/media/focusarea.f2b26bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/focusarea.png
// module id = 887
// module chunks = 0